import { Store } from "pullstate";

type CertificateTemplateInfoStoreProps = {
  certificateTemplateId: string | undefined;
  isLandscape: boolean | null;
};

const certificateTemplateInfoStore = new Store<CertificateTemplateInfoStoreProps>({
  certificateTemplateId: undefined,
  isLandscape: null,
});

export default certificateTemplateInfoStore;
